export default function generatedID( prefix: string ) {
    return `${prefix}-${iterator.next().value}`
}

const iterator = get();

function* get() {
    let i = 1234;

    while (true) {
        yield i++;
    }
}